import { Users, Link2 } from "lucide-react";

// Pole klienta – vybírá se jen z číselníku (otevře ClientPicker), bez volného textu.
export function ClientField({ label = "Klient", value, linked, onOpen, testid }) {
    return (
        <div>
            <label className="label-eyebrow block mb-1.5">{label}</label>
            <button type="button" onClick={onOpen} data-testid={testid}
                    className={`w-full min-h-[42px] px-3 py-2 border text-sm text-left rounded-sm flex items-center gap-2 hover:border-orange-600 ${value ? "border-slate-300 bg-white text-slate-900" : "border-dashed border-slate-400 bg-slate-50 text-slate-500"}`}>
                <Users className="w-4 h-4 text-orange-600 shrink-0" />
                <span className="flex-1 truncate">{value || "Vybrat klienta z číselníku…"}</span>
                {value && linked && <Link2 className="w-3.5 h-3.5 text-emerald-600" title="Propojeno s číselníkem" />}
                {value && !linked && <span className="text-[10px] uppercase text-amber-700 font-bold" title="Jen text – klikněte a vyberte z číselníku">nepropojeno</span>}
            </button>
        </div>
    );
}
